import Swiper from "swiper";
import dateFormat from "dateformat";

export class DateRdv {
    constructor() {
        this.env = document.querySelector('#multi-step-form-container').getAttribute('data-base-url');
        this.idCenter = 0;
        this.idMotif = 0;
    }

    setIds() {
        let centers = document.querySelectorAll('input[type=radio][name="center-item-radio"]');

        centers.forEach((center) => {
            if (center.checked) {
                 this.idCenter = center.getAttribute('data-id-center');
                 this.idMotif  = center.getAttribute('data-id-motif');
            }
        });
    }

    fetchDates() {
        let appt = this;
        let windows = window.screen.width;
        let dateSince  = dateFormat(new Date(), 'dd-mm-yyyy');
        let timeSince  = '09:00';
        let maxResults = '816';

        let urlApi = this.env + 'availability?center=' + this.idCenter + '&motive=' + this.idMotif + '&datesince=' + dateSince + '&timesince=' + timeSince + '&maxresults=' + maxResults;

        fetch(urlApi)
            .then(response => response.json())
            .then(function (data) {
                if (data.data.length !== 0) {
                    let availablesDatesSection = document.querySelector('.available-dates');
                    let dates = data.data;
                    let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

                    if (windows > 992) {
                        /* display desktop */
                        let slide              = availablesDatesSection.querySelector('.swiper-wrapper .swiper-slide');
                        let errorAviabilityRow = availablesDatesSection.querySelector('#error-aviability-info');
                        if (!(errorAviabilityRow.classList.contains('d-none'))) {
                            console.log('est affiché');
                            errorAviabilityRow.classList.add('d-none');
                            if (document.querySelector('.swiper-container-rdv-dates').classList.contains('d-none')) {
                                document.querySelector('.swiper-container-rdv-dates').classList.remove('d-none');
                            }
                        }
                        if (typeof(slide) !== 'undefined' && slide !== null) {
                            //console.log(slide);
                            //Destruction des div dates.
                            document.querySelector('.swiper-container-rdv-dates').remove();
                            document.querySelector('.tabs_content_date').remove();

                            //Reconstruction des div dates
                            availablesDatesSection.innerHTML +=
                                "<div class=\"swiper-container-rdv-dates\">"+
                                "<div class=\"swiper-wrapper\">"+
                                "</div>"+
                                "<!-- Add Arrows -->"+
                                "<div class=\"swiper-button-next\"></div>"+
                                "<div class=\"swiper-button-prev\"></div>"+
                                "</div>"+
                                "<div class=\"tabs_content_date\">"+
                                "</div>";
                        }
                        Object.keys(dates).forEach(function(k){
                            let arrayDate = k.split("/");
                            let day   = arrayDate[0];
                            let month = arrayDate[1];
                            let year  = arrayDate[2];
                            let itemDatePrint = new Date(month+"/"+day+"/"+year).toLocaleDateString("fr-FR", options);

                            availablesDatesSection.querySelector('.swiper-wrapper').innerHTML +=
                                "<div class=\"swiper-slide\">"+
                                "<button class=\"tabs_btn_date\" type=\"button\">" + itemDatePrint + "</button>"+
                                "</div>" ;
                            //console.log(k + ' - ' + dates[k]);
                        });
                        let tabsContentDate = availablesDatesSection.querySelector('.tabs_content_date');
                        let cpt = 0;
                        Object.keys(dates).forEach(function(k){
                            let arrayDate = k.split("/");
                            let day   = arrayDate[0];
                            let month = arrayDate[1];
                            let year  = arrayDate[2];
                            let itemDatePrint = new Date(month+"/"+day+"/"+year).toLocaleDateString("fr-FR", options);

                            tabsContentDate.innerHTML +=
                                "<div id=\"date-row-"+ cpt +"\" class=\"dates-content-row d-none show-more-content\">";
                            Array.from(dates[k]).forEach(function(value){
                                tabsContentDate.querySelector('#date-row-'+cpt).innerHTML +=
                                    "<div class=\"date-item\">" +
                                    "<input type=\"radio\" " +
                                    "name=\"date-item-radio\" " +
                                    "id=\"" + day+"-"+month+"-"+year+"-"+value +"\" " +
                                    "value=\"" + day+"-"+month+"-"+year+"/"+value +"\" " +
                                    "data-date-print=\"" + itemDatePrint+" "+value +"\"/>" +
                                    "<label class=\"date-item-label\" for=\""+ day+"-"+month+"-"+year+"-"+value +"\">" + value +"</label>" +
                                    "</div>";
                            });
                            tabsContentDate.querySelector('#date-row-'+cpt).innerHTML +=
                                "<div class=\"show-more-dates d-none\">Voir plus de créneaux</div>";
                            cpt++;
                        });

                        const swiperRdvDates = new Swiper(".swiper-container-rdv-dates", {
                            slidesPerView: 4,
                            spaceBetween: 30,
                            slidesPerGroup: 4,
                            loop: false,
                            loopFillGroupWithBlank: true,
                            navigation: {
                                nextEl: ".swiper-button-next",
                                prevEl: ".swiper-button-prev"
                            }
                        });
                    }
                    else {
                        /* display mobile */
                        let cptMobile = 0;
                        Object.keys(dates).forEach(function(k){
                            let arrayDate = k.split("/");
                            let day   = arrayDate[0];
                            let month = arrayDate[1];
                            let year  = arrayDate[2];
                            let itemDatePrint = new Date(month+"/"+day+"/"+year).toLocaleDateString("fr-FR", options);

                            availablesDatesSection.querySelector('.mobile-container-rdv-dates').innerHTML +=
                                "<div class=\"mobile-accordion-date\">" +
                                "<button class=\"mobile-accordion-btn-date\" type=\"button\">" + itemDatePrint + "</button>" +
                                "<div id=\"mobile-accordion-content-date-"+cptMobile+"\" class=\"mobile-accordion-content-date show-more-content\">" +
                                "</div>" +
                                "</div>";
                            cptMobile++;
                        });
                        let cptMobileContent = 0;
                        Object.keys(dates).forEach(function(k){
                            let arrayDate = k.split("/");
                            let day   = arrayDate[0];
                            let month = arrayDate[1];
                            let year  = arrayDate[2];
                            let itemDatePrint = new Date(month+"/"+day+"/"+year).toLocaleDateString("fr-FR", options);

                            Array.from(dates[k]).forEach(function(value){
                                availablesDatesSection.querySelector('#mobile-accordion-content-date-'+cptMobileContent).innerHTML +=
                                    "<div class=\"date-item\">" +
                                    "<input type=\"radio\" " +
                                    "name=\"date-item-radio\" " +
                                    "id=\"" + day+"-"+month+"-"+year+"-"+value +"\" " +
                                    "value=\"" + day+"-"+month+"-"+year+"/"+value +"\" " +
                                    "data-date-print=\"" + itemDatePrint+" "+value +"\"/>" +
                                    "<label class=\"date-item-label\" for=\""+ day+"-"+month+"-"+year+"-"+value +"\">" + value +"</label>" +
                                    "</div>";
                            });
                            availablesDatesSection.querySelector('#mobile-accordion-content-date-'+cptMobileContent).innerHTML +=
                                "<div class=\"show-more-dates d-none\">Voir plus de créneaux</div>";
                            cptMobileContent++;
                        });
                    }

                    appt.datesTabsHandler();
                    appt.datesShowMoreHandler();
                    appt.datesLabelHandler();
                    appt.dateContentAccordion();
                }
                else {
                    console.log('Il y a aucune dates');

                    let availablesDatesSection = document.querySelector('.available-dates');
                    let errorAviability        = availablesDatesSection.querySelector('#error-aviability-info');
                    let swiperDates            = availablesDatesSection.querySelector('.swiper-container-rdv-dates');
                    let buttonNext             = document.querySelector('#step-2 .button-row .button-next');

                    errorAviability.classList.remove('d-none');
                    swiperDates.classList.add('d-none');
                    buttonNext.setAttribute('disabled', 'true');
                }

            })
            .catch(function (err) {
                console.log('Il y a une erreur avec le fetch : ' + err.message);

                let availablesDatesSection = document.querySelector('.available-dates');
                let errorAviability        = availablesDatesSection.querySelector('#error-aviability-info');
                let swiperDates            = availablesDatesSection.querySelector('.swiper-container-rdv-dates');
                let buttonNext             = document.querySelector('#step-2 .button-row .button-next');

                errorAviability.classList.remove('d-none');
                swiperDates.classList.add('d-none');
                buttonNext.setAttribute('disabled', 'true');
            });

    }

    fetchcall () {
        let appt = this;
        // (B1) GET FORM DATA
        //var data = new FormData(document.getElementById("RdvDateSetupForm"));
        const data = {
            'civilite'    : document.querySelector('#civilite').innerHTML,
            'firstname'   : document.querySelector('#firstname').innerHTML,
            'lastname'    : document.querySelector('#lastname').innerHTML,
            'visionType'  : document.querySelector('#vision-type').innerHTML,
            'email'       : document.querySelector('#email').innerHTML,
            'tel'         : document.querySelector('#tel').innerHTML,
            'address'     : document.querySelector('#address').innerHTML,
            'cp'          : document.querySelector('#cp').innerHTML,
            'birthDate'   : document.querySelector('#birth-date').innerHTML,
            'date'        : document.querySelector('#rdv-date-value').innerHTML,
            'idCenter'    : this.idCenter,
            'idMotif'     : this.idMotif,
            'referer'     : window.location.href
        };
        // (B2) FETCH
        fetch("/wp-json/wp/v2/rdv-post", { method: "POST", body: JSON.stringify(data) })
            /*.then(res => res.text())
            .then(txt => console.log(txt))*/
            .then(function (res) {
                if (res.ok) {
                    let resultApi  = res.json();
                    let rdvchirContainer = document.querySelector('.rdv-chir');
                    let form = rdvchirContainer.querySelector('#multi-step-form-container');

                    let validationTitle   = rdvchirContainer.querySelector('#validation-title');
                    let validationContent = rdvchirContainer.querySelector('#validation-content');
                    let dataValidation = {
                        'title'   : form.getAttribute('data-validation-title')
                    }
                    resultApi.then(json => {
                        if (json.rdv.status === 'error') {
                            //console.log(json.rdv.message);
                            form.remove();
                            validationTitle.classList.replace('done','error-validation');
                            validationTitle.innerHTML ="RDV Invalide";
                            validationContent.innerHTML = "<p>"+json.rdv.message+"</p>";
                            appt.removeValidationData(validationTitle, validationContent);
                        }
                        else {
                            //console.log(json.rdv.message);
                            form.remove();
                            appt.removeValidationData(validationTitle, validationContent);

                        }
                    });
                }
                else {
                    console.log('Erreur avec les datas');
                }
            })
            .catch(function (err) {
                console.log('Il y a une erreur avec le fetch : ' + err.message);
            });
        return false;
    }

    removeValidationData(content1, content2) {
        content1.classList.remove('d-none');
        content2.classList.remove('d-none');
    }

    datesTabsHandler() {
        let datesButton  = document.querySelectorAll('.tabs_btn_date');
        let datesContent = document.querySelectorAll('.dates-content-row');


        let tabNo     = 0;
        let contentNo = 0;

        datesButton.forEach((tab) => {
            if (tabNo === 0) {
                tab.classList.add('active');
            }
            tab.dataset.id = tabNo;
            tabNo++;
            tab.addEventListener("click", function () {
                datesButton.forEach((tab) => {
                    tab.classList.remove("active");
                    tab.classList.add("non-active");
                });
                this.classList.remove("non-active");
                this.classList.add("active");
                datesContent.forEach((content) => {
                    content.classList.add('d-none');
                    if (content.dataset.id === tab.dataset.id) {
                        content.classList.remove('d-none');
                    }
                });
            });
        });

        datesContent.forEach((content) => {
            if (contentNo === 0) {
                content.classList.remove('d-none');
            }
            content.dataset.id = contentNo;
            contentNo++;
        });

    }

    datesShowMoreHandler() {
        let datesContent = document.querySelectorAll('.dates-content-row');

        datesContent.forEach((content) => {
            let dates = content.querySelectorAll('.date-item');
            let showMore = content.querySelector('.show-more-dates');

            if (dates.length > 16) {
                showMore.classList.remove('d-none');
                showMore.addEventListener('click', ()=> {
                    if (content.classList.contains('show-more-content')) {
                        showMore.innerHTML = 'Voir moins de créneaux';
                    }
                    else {
                        showMore.innerHTML = 'Voir plus de créneaux';
                    }
                    content.classList.toggle('show-more-content');
                });
            }
        });

        let mobileDateContent = document.querySelectorAll('.mobile-accordion-content-date');

        mobileDateContent.forEach((contentMobile) => {
            let mobileDates = contentMobile.querySelectorAll('.date-item');
            let mobileShowMore = contentMobile.querySelector('.show-more-dates');
            if (mobileDates.length > 6) {
                mobileShowMore.classList.remove('d-none');
                mobileShowMore.addEventListener('click', ()=> {
                    if (contentMobile.classList.contains('show-more-content')) {
                        mobileShowMore.innerHTML = 'Voir moins de créneaux';
                    }
                    else {
                        mobileShowMore.innerHTML = 'Voir plus de créneaux';
                    }
                    contentMobile.classList.toggle('show-more-content');
                });
            }
        });
    }

    datesLabelHandler(){
        const data = {
            'dateLabel'     : document.querySelector('#label-date'),
            'dateInput'     : document.querySelector('#rdv-date'),
            'dateValue'     : document.querySelector('#rdv-date-value'),
        };

        let dates = document.querySelectorAll('input[type=radio][name="date-item-radio"]');

        dates.forEach(date => date.addEventListener('change',()=> {
            data.dateLabel.innerHTML = date.getAttribute('data-date-print');
            data.dateInput.innerHTML = date.getAttribute('data-date-print');
            data.dateValue.innerHTML = date.value;
        }));

    }

    dateContentAccordion() {
        let accordionButtonDates = document.querySelectorAll('.mobile-accordion-btn-date');
        
        accordionButtonDates.forEach(function (buttonDate, contentDate) {
            buttonDate.addEventListener('click', function (e) {
                e.preventDefault();

                this.parentNode.classList.toggle('on');

                accordionButtonDates.forEach(function (buttonDate2,contentDate2) {
                    if (contentDate !== contentDate2) {
                        buttonDate2.parentNode.classList.remove('on');
                    }
                })
            })
        })
    }

}